import React from 'react';

import styled from '@emotion/styled';

import { Modal } from '../../components/Modal/Modal';
import { TableComponent } from '../../components/TableCom';
import { ModalProvider } from '../../context/ModalContext';
import { TableRefreshProvider } from '../../context/TableRefreshContext';
import CreateWarehouser from '../../sections/dashboard/users/CreateWarehouser';
import CreateWarehouserModal from '../../sections/dashboard/users/CreateWarehouserModal';

const WarehouserUser = () => {
  return (
    <TableRefreshProvider>
      <ModalProvider>
        <Container>
          <CreateWarehouser />
          <TableComponent
            tableBaseUrl="authentication-service/v1/warehouse/users"
            tableHeader={[
              'firstName',
              'lastName',
              'warehouseRole',
              'phoneNumber',
              'verified',
            ]}
            mappingData={{
              firstName: 'First Name',
              lastName: 'Last Name',
              warehouseRole: 'Role',
              phoneNumber: 'Phone Number',
              verified: 'Verified',
            }}
          />
        </Container>
        <Modal>
          <CreateWarehouserModal />
        </Modal>
      </ModalProvider>
    </TableRefreshProvider>
  );
};

export default WarehouserUser;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;
